
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.5 12.5h-4a1 1 0 01-1-1v-8a1 1 0 011-1h9a1 1 0 011 1v3m-11-1h11m-8-2v-2m5 2v-2m3 7a4 4 0 11-.001 8.001A4 4 0 0112.5 8.5z"}}),_c('path',{attrs:{"d":"M14.268 12.5H12.5v-1.767"}})])])
          )
        }
      }
    